import React, { forwardRef, useMemo } from 'react';
import { FiChevronDown } from 'react-icons/fi';

import {
  IconWrapper,
  StyledBrazilianStateSelect,
  StyledBrazilianStateSelectLabel,
  StyledSelect,
  ErrorText,
  Wrapper,
} from './styles';
import { getSortedBrazilianStates } from '@src/common/auth';

type BrazilianStateSelectProps = {
  label?: string;
  name?: string;
  required?: boolean;
  defaultValue?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  disabled?: boolean;
  error?: string | null;
  fullWidth?: boolean;
};

const BrazilianStateSelect = forwardRef<HTMLSelectElement, BrazilianStateSelectProps>(
  (props: BrazilianStateSelectProps, inputRef: React.Ref<HTMLSelectElement>) => {
    const { label, name, required, defaultValue = '', value, onChange, disabled, error, fullWidth } = props;

    const sortedBrazilianStates = useMemo(() => getSortedBrazilianStates(), []);

    return (
      <Wrapper fullWidth={fullWidth}>
        {label ? <StyledBrazilianStateSelectLabel>{label}</StyledBrazilianStateSelectLabel> : null}

        <StyledSelect hasError={!!error}>
          <StyledBrazilianStateSelect
            required={required}
            name={name}
            defaultValue={defaultValue}
            value={value}
            onChange={onChange}
            ref={inputRef}
            disabled={disabled}
          >
            <option key={`state-undefined`} value='' selected disabled></option>

            {sortedBrazilianStates.map((state) => (
              <option key={`state-${state.abbreviation}`} value={state.abbreviation}>
                {state.name}
              </option>
            ))}
          </StyledBrazilianStateSelect>

          <IconWrapper>
            <FiChevronDown size={24} />
          </IconWrapper>
        </StyledSelect>

        {error ? <ErrorText>{error}</ErrorText> : null}
      </Wrapper>
    );
  },
);

BrazilianStateSelect.displayName = 'BrazilianStateSelect';

export default BrazilianStateSelect;
